export default __webpack_public_path__ + "static/media/519.7e7f4c90.png";